import { CircularProgress } from 'library/loaders';
import { FC, forwardRef } from 'react';
import Button, { ButtonProps } from './Button';

export interface LoadingButtonProps extends ButtonProps {
    isLoading?: boolean;
    loadingText?: string;
}

const LoadingButton = forwardRef<HTMLButtonElement, LoadingButtonProps>((props, ref) => {
    const { isLoading = false, loadingText, children, disabled, ...rest } = props;

    return (
        <Button {...rest} ref={ref} disabled={isLoading || disabled}>
            {!isLoading ? (
                children
            ) : (
                <div className="flex items-center gap-3 justify-center">
                    {<CircularProgress size={'1em'} />} {loadingText ? loadingText : children}
                    ...
                </div>
            )}
        </Button>
    );
});

export default LoadingButton;
